import { LIST_ITEM } from '../constants/editable-elements';

const shouldUpdateNumberedList = (prefix, listNode) =>
  prefix === `${listNode.querySelectorAll(LIST_ITEM).length + 1}.`;

export default shouldUpdateNumberedList;
